export default "__VITE_ASSET__CbGhcy31__"